module.exports = __webpack_public_path__ + "img/541.31035385.png";